export default "__VITE_ASSET__BrtZAd_8__"